type Props = {
  readonly error?: {
    id: string;
    message: string;
  };
};

export function SelectLoadError({ error }: Props) {
  return error ? (
    <small
      className="mt-1 block text-xs text-tiga-semantic-error"
      id={error.id}
      role="alert"
    >
      {error.message}
    </small>
  ) : null;
}
